import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { PAYMENT_DASHBOARD_ANALYTICS_ACTIONS } from './payment-dashboard-analytics.action';
import { PaymentDashboardAnalyticsMessages } from './payment-dashboard-analytics.constants';
import {
  paymentDashboardModalOpen,
  paymentDashboardPageLoad,
  paymentDashboardSearch,
  paymentOutboundLink,
  paymentTileClick,
} from './payment-dashboard-analytics.transformers';

@Injectable({
  providedIn: 'root',
})
export class PaymentDashboardAnalyticsService {
  constructor(private store: Store) {}

  trackPageLoad() {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentDashboardAnalyticsMessages.capability,
          event: PaymentDashboardAnalyticsMessages.pageLoadedEvent,
          pageName: PaymentDashboardAnalyticsMessages.pageName,
        },
        transformFunc: paymentDashboardPageLoad,
      },
    };
    this.store.dispatch(
      PAYMENT_DASHBOARD_ANALYTICS_ACTIONS.trackPageLoad({ tracking }),
    );
  }

  trackTileClick(tileTitle: string) {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentDashboardAnalyticsMessages.capability,
          event: PaymentDashboardAnalyticsMessages.tileClick,
          pageName: PaymentDashboardAnalyticsMessages.pageName,
          buttonName: tileTitle,
        },
        transformFunc: paymentTileClick,
      },
    };
    this.store.dispatch(
      PAYMENT_DASHBOARD_ANALYTICS_ACTIONS.trackTileClick({ tracking }),
    );
  }

  trackOutboundLink(linkURL: string) {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentDashboardAnalyticsMessages.capability,
          event: PaymentDashboardAnalyticsMessages.outboundLinkEvent,
          pageName: PaymentDashboardAnalyticsMessages.pageName,
          linkURL,
        },
        transformFunc: paymentOutboundLink,
      },
    };
    this.store.dispatch(
      PAYMENT_DASHBOARD_ANALYTICS_ACTIONS.trackOutboundLink({ tracking }),
    );
  }

  trackSearch(searchTerm: string) {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentDashboardAnalyticsMessages.capability,
          event: PaymentDashboardAnalyticsMessages.searchTerm,
          pageName: PaymentDashboardAnalyticsMessages.pageName,
          searchTerm,
        },
        transformFunc: paymentDashboardSearch,
      },
    };
    this.store.dispatch(
      PAYMENT_DASHBOARD_ANALYTICS_ACTIONS.trackSearch({ tracking }),
    );
  }

  trackModalOpen() {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentDashboardAnalyticsMessages.capability,
          event: PaymentDashboardAnalyticsMessages.modalOpen,
          pageName: PaymentDashboardAnalyticsMessages.pageName,
          modalName: PaymentDashboardAnalyticsMessages.modalName,
        },
        transformFunc: paymentDashboardModalOpen,
      },
    };
    this.store.dispatch(
      PAYMENT_DASHBOARD_ANALYTICS_ACTIONS.trackModalOpen({ tracking }),
    );
  }
}
